<script setup lang="ts">
import { IconMastercard, IconVisa, IconPaypal, IconFedex, IconVenipak, IconDpd, IconApplePay, IconGooglePay, IconLpExpress } from '#components'

const icons = [IconApplePay, IconGooglePay, IconMastercard, IconVisa, IconPaypal, IconFedex, IconDpd, IconVenipak, IconLpExpress]
</script>

<template>
  <div class="_row _inline _wrap _gap1">
    <div v-for="(icon, index) in icons" :key="index" :class="$style.b" class="_row _ctrY _h40">
      <div class="_h18"><component :is="icon" class="_h18" /></div>
    </div>
  </div>
</template>

<style module>
.b img,
.b svg {
  max-width: initial;
}
</style>
